import type { FC, ReactNode } from "react";
import { useAuth } from "../hooks/use-auth";
import { Navigate, useLocation } from "react-router-dom";

interface GuestGuardProps {
  children: ReactNode;
}

export const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const returnTo = searchParams.get("returnTo") || undefined;

  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={returnTo || "/"} />;
  }
  return <>{children}</>;
};
